var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('span',{staticClass:"customer-brand-logo",class:[
    'customer-brand-logo--' + _vm.variant,
    'customer-brand-logo--' + _vm.context,
    'customer-brand-logo--surface-' + _vm.resolvedSurface ]},[_c('img',{staticClass:"customer-brand-logo__image",attrs:{"src":_vm.source,"alt":_vm.alt},on:{"load":_vm.detectLogoContrast}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }